import * as Yup from 'common/yup';
import {ServerTypeName} from 'common/enums';

export const serverTypeNameSchema = Yup.mixed<ServerTypeName>()
   .oneOf(Object.values(ServerTypeName))
   .defined();
